<div class="content">
<button [ngClass]="{'active': active === i}" *ngFor="let menu of menus; index as i" (click)="goTo(i)">{{ menu }}</button>
<div class="line"></div>
</div>